import { render } from "./HotelTable.vue?vue&type=template&id=4e6636e7&scoped=true"
import script from "./HotelTable.vue?vue&type=script&lang=js"
export * from "./HotelTable.vue?vue&type=script&lang=js"

import "./HotelTable.vue?vue&type=style&index=0&id=4e6636e7&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6636e7"]])

export default __exports__